import { useState } from 'react';

import { BlockData } from 'types';
import useCSVDataForm from './useCSVDataForm';

interface UseCSVDataViewerParams {
  id: string;
  blockData: BlockData;
}

const useCSVDataViewer = ({ id, blockData }: UseCSVDataViewerParams) => {
  const [mode, setMode] = useState<'edit' | 'delete' | ''>('');
  const [checkColumnIndexes, setCheckColumnIndexes] = useState<number[]>([]);

  const useCSVDataFormReturn = useCSVDataForm({ id, blockData });
  const { nodeDataSave, nodeDataReset, addColumn, deleteColumns } = useCSVDataFormReturn;

  const isEditMode = mode === 'edit';
  const isDeleteMode = mode === 'delete';

  const handleAddColumnClick = () => {
    addColumn();
  };

  const handleEditModeClick = () => {
    setMode('edit');
  };

  const handleDeleteModeClick = () => {
    setMode('delete');
  };

  const handleColumnCheck = (event: React.FormEvent<HTMLInputElement>, index: number) => {
    if (event.currentTarget.checked) {
      setCheckColumnIndexes((prevIndexes) => [...prevIndexes, index]);
    } else {
      setCheckColumnIndexes((prevIndexes) => prevIndexes.filter((value) => value !== index));
    }
  };

  const handleConfirmClick = () => {
    if (isEditMode) {
    } else if (isDeleteMode) {
      deleteColumns(checkColumnIndexes);
      setCheckColumnIndexes([]);
    }
    setMode('');
    nodeDataSave();
  };

  const handleCancelClick = () => {
    if (isEditMode) {
      nodeDataReset();
    } else if (isDeleteMode) {
      setCheckColumnIndexes([]);
    }
    setMode('');
  };

  return {
    ...useCSVDataFormReturn,
    isEditMode,
    isDeleteMode,
    onAddColumnClick: handleAddColumnClick,
    onCancelClick: handleCancelClick,
    onColumnCheck: handleColumnCheck,
    onConfirmClick: handleConfirmClick,
    onDeleteModeClick: handleDeleteModeClick,
    onEditModeClick: handleEditModeClick,
  };
};

export default useCSVDataViewer;
